import { render, staticRenderFns } from "./EmptyEntityPlaceholder.vue?vue&type=template&id=381b6dbc&scoped=true&lang=pug&"
import script from "./EmptyEntityPlaceholder.vue?vue&type=script&lang=js&"
export * from "./EmptyEntityPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./EmptyEntityPlaceholder.vue?vue&type=style&index=0&id=381b6dbc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b6dbc",
  null
  
)

export default component.exports